'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _createClass = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _text = require('components/field/text');

var _text2 = _interopRequireDefault(_text);

var _exports = require('exports');

var _exports2 = _interopRequireDefault(_exports);

var _animationHelper = require('animation-helper');

var _animationHelper2 = _interopRequireDefault(_animationHelper);

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

var _shareModal = require('share-modal');

var _shareModal2 = _interopRequireDefault(_shareModal);

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

var _contactInfo = require('contact-info');

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function cleanMarkup(markup) {
	var toRemove = [{ all: false, start: '<!--', end: '-->' }, { all: true, start: '<style', end: '</style>' }, { all: false, start: '<meta', end: '>' }, { all: false, start: '<link', end: '>' }, { all: false, value: '</meta>' }, { all: false, value: '<o:p>' }, { all: false, value: '</o:p>' }];
	var word = markup.indexOf('Word.Document') != -1;

	toRemove.filter(function (entry) {
		return word || entry.all;
	}).forEach(function (entry) {
		if (entry.value) {
			while (markup.indexOf(entry.value) != -1) {
				markup = markup.replace(entry.value, '');
			}return;
		}
		do {
			var begin = markup.indexOf(entry.start);
			if (begin == -1) return;

			var end = markup.indexOf(entry.end, begin + entry.start.length);
			var left = markup.substring(0, begin);
			var right = markup.substring(end + entry.end.length);
			markup = left + right;
		} while (true);
	});

	return markup;
}

var ProductSection = function (_Component) {
	_inherits(ProductSection, _Component);

	function ProductSection() {
		_classCallCheck(this, ProductSection);

		return _possibleConstructorReturn(this, (ProductSection.__proto__ || Object.getPrototypeOf(ProductSection)).apply(this, arguments));
	}

	_createClass(ProductSection, [{
		key: 'render',
		value: function render() {
			if (this.props.content) {
				return _react2.default.createElement('div', { className: 'product-description-section' }, _react2.default.createElement('header', null, this.props.title), _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: cleanMarkup(this.props.content) } }));
			}
			return null;
		}
	}]);

	return ProductSection;
}(_react.Component);

var Product = function (_Component2) {
	_inherits(Product, _Component2);

	_createClass(Product, null, [{
		key: 'serverRender',
		value: function serverRender(page, group, product) {
			var recordPath = _exports2.default.Link('product-detail', { group: group, record: product });
			var shareLink = _exports2.default.GetShareLink('product-detail', { group: group, record: product });

			var groupList = [],
			    current = group;
			while (current) {
				groupList.unshift({ group: JSON.parse(JSON.stringify(current)), link: _exports2.default.Link('shop', current) });
				current = current.parent;
			}

			var locationGroup = page.blockFromLayout('MainLayout', 'Locations').resolve();
			var locations = [].map.call(locationGroup.records, function (location) {
				return {
					id: location.id,
					name: location.location,
					address: location.address,
					city: location.city,
					state: location.state,
					zip: location.zip
				};
			});

			product = JSON.parse(JSON.stringify(product));
			return '\n\t\t\t<div data-component="Product">' + _server2.default.renderToString(_react2.default.createElement(Product, { groupList: groupList, product: product, productLink: recordPath, shareLink: shareLink, locations: locations })) + '</div>\n\t\t\t' + page.inlineScript('\n\t\t\t\tvar groupList = ' + JSON.stringify(groupList) + ';\n\t\t\t\tvar product = ' + JSON.stringify(product) + ';\n\t\t\t\tvar productLink = ' + JSON.stringify(recordPath) + ';\n\t\t\t\tvar shareLink = ' + JSON.stringify(shareLink) + ';\n\t\t\t\tvar locations = ' + JSON.stringify(locations) + ';\n\t\t\t\trequire(\'products/detail\').default.clientRender(this.querySelector(\'[data-component=Product]\'), groupList, product, productLink, shareLink, locations);\n\t\t\t') + '\n\t\t';
		}
	}, {
		key: 'clientRender',
		value: function clientRender(node, groupList, product, productLink, shareLink, locations) {
			_reactDom2.default.render(_react2.default.createElement(Product, { groupList: groupList, product: product, productLink: productLink, shareLink: shareLink, locations: locations }), node);
		}
	}]);

	function Product(props) {
		_classCallCheck(this, Product);

		var _this2 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props));

		_this2.state = {
			name: "",
			email: "",
			phone: "",
			location: "",
			submitting: false,
			submitted: false
		};
		if (props.person) {
			Object.assign(_this2.state, props.person, { submitting: false, submitted: false });
		}
		_this2.share = _this2.share.bind(_this2);
		_this2.pickUp = _this2.pickUp.bind(_this2);
		_this2.gotPickupForm = _this2.gotPickupForm.bind(_this2);
		_this2.submitForm = _this2.submitForm.bind(_this2);
		return _this2;
	}

	_createClass(Product, [{
		key: 'share',
		value: function share() {
			_shareModal2.default.show(this.props.product.title, this.props.shareLink);
		}
	}, {
		key: 'gotPickupForm',
		value: function gotPickupForm(node) {
			this.form = node;
		}
	}, {
		key: 'pickUp',
		value: function pickUp() {
			var _this3 = this;

			this.setState({ submitting: false, submitted: false }, function () {
				return (0, _jQuery2.default)(_this3.form).slideToggle();
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this4 = this;

			if (!this.state.location) {
				(0, _contactInfo.getLocation)().then(function (info) {
					if (info.Location) _this4.setState({ location: info.Location.id });
				});
			}
		}
	}, {
		key: 'submitForm',
		value: function submitForm() {
			var _this5 = this;

			this.setState({ submitting: true, submitted: false }, function () {
				// Debug
				setTimeout(function () {
					_this5.setState({ submitted: true, submitting: false });
				}, 500);
				return;

				var xhr = new XMLHttpRequest();
				xhr.open('POST', 'data/pickup', true);
				xhr.setRequestHeader('Content-Type', 'application/json');
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
						_this5.setState({ submitted: true, submitting: false });
					}
				};
				xhr.send(JSON.stringify({
					name: _this5.state.name,
					phone: _this5.state.phone,
					email: _this5.state.email,
					location: _this5.state.location,
					product: _this5.props.product.id
				}));
			});
		}
	}, {
		key: 'locationForId',
		value: function locationForId(id) {
			return this.props.locations.filter(function (location) {
				return location.id == id;
			})[0];
		}
	}, {
		key: 'render',
		value: function render() {
			var _this6 = this;

			return _react2.default.createElement('div', { className: 'col-md-8 col-md-offset-2 services-detail product-detail' }, _react2.default.createElement('div', { className: 'services-detail-header header' }, _react2.default.createElement('div', { className: 'inner-content' }, _react2.default.createElement('div', { className: 'navigation uppercase' }, _react2.default.createElement('h4', null, this.props.groupList.map(function (item, index) {
				return _react2.default.createElement('span', { key: index }, index ? _react2.default.createElement('span', null, ' / ') : null, index != 1 ? _react2.default.createElement('span', null, item.group.title) : _react2.default.createElement('a', { href: item.link }, item.group.title));
			}))), _react2.default.createElement('div', { className: 'share-button', onClick: this.share }, _react2.default.createElement('div', { className: 'left' }, _react2.default.createElement('p', null, 'Share')), _react2.default.createElement('div', { className: 'right' }, _react2.default.createElement('img', { className: 'img-responsive share-icon', src: '/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/share-icon.png' }))))), _react2.default.createElement('div', { className: 'product-content' }, _react2.default.createElement('div', { className: 'left' }, _react2.default.createElement('img', { className: 'img-responsive', src: this.props.product.image_name })), _react2.default.createElement('div', { className: 'right' }, _react2.default.createElement('h1', { className: 'uppercase' }, this.props.product.title), this.props.product.tagline ? _react2.default.createElement('h2', { className: 'tagline' }, this.props.product.tagline) : null, _react2.default.createElement('div', { className: 'button-wrapper' }, _react2.default.createElement('div', { className: 'price' }, _react2.default.createElement('p', null, '$58.99')), _react2.default.createElement('div', { className: 'pickup-btn', onClick: this.pickUp }, _react2.default.createElement('p', { className: 'uppercase' }, 'In-Store Pick Up'))))), _react2.default.createElement('hr', { style: { marginBottom: '0px' } }), _react2.default.createElement('div', { className: _classList2.default.join('pickup-form', this.state.submitted ? 'sent' : null), ref: this.gotPickupForm }, _react2.default.createElement('div', { className: 'inner-content' }, this.state.submitted ? _react2.default.createElement('div', { className: 'thankYou', ref: function ref(node) {
					return node ? node.dataset.ready = 'true' : null;
				} }, _react2.default.createElement('h2', { className: 'uppercase' }, 'Thank You!'), _react2.default.createElement('p', null, 'We\'ll see you soon at our ', _react2.default.createElement('i', null, this.locationForId(this.state.location).name), ' location.')) : null, _react2.default.createElement('div', { className: 'header' }, _react2.default.createElement('h2', { className: 'uppercase' }, 'Pick Up In-Store'), _react2.default.createElement('p', null, 'Fill in your information and a preferred location. We\'ll have it ready for pick up within 1 hour. Your orders will remain available for 72 hours.')), _react2.default.createElement('div', { className: 'simple-form' }, _react2.default.createElement('div', { className: 'form-group' }, _react2.default.createElement('input', { className: 'form-control', placeholder: 'Your Name', type: 'text', value: this.state.name, onChange: function onChange(event) {
					return _this6.setState({ name: event.target.value });
				}, disabled: this.state.submitting || this.state.submitted })), _react2.default.createElement('div', { className: 'form-group' }, _react2.default.createElement('input', { className: 'form-control', placeholder: 'Email', type: 'email', value: this.state.email, onChange: function onChange(event) {
					return _this6.setState({ email: event.target.value });
				}, disabled: this.state.submitting || this.state.submitting })), _react2.default.createElement('div', { className: 'form-group' }, _react2.default.createElement('input', { className: 'form-control', placeholder: 'Phone', type: 'text', value: this.state.phone, onChange: function onChange(event) {
					return _this6.setState({ phone: event.target.value });
				}, disabled: this.state.submitting || this.state.submitting })), this.props.locations.map(function (location) {
				return _react2.default.createElement('div', { className: 'radio', key: location.id }, _react2.default.createElement('label', null, _react2.default.createElement('input', { type: 'radio', name: 'location', value: location.id, checked: _this6.state.location == location.id, onChange: function onChange(event) {
						return _this6.setState({ location: location.id });
					}, disabled: _this6.state.submitting || _this6.state.submitting }), _react2.default.createElement('span', { className: 'large' }, location.name), ' - ', location.address, ', ', location.city, ', ', location.state, ' ', location.zip));
			})), _react2.default.createElement('button', { disabled: !this.canSubmitForm && !this.state.submitting && !this.state.submitting, onClick: this.submitForm, className: 'btn btn-primary' }, 'Done'))), _react2.default.createElement('div', { className: 'description' }, this.sections()), _react2.default.createElement('div', { className: 'services-detail-footer' }, _react2.default.createElement('hr', null), _react2.default.createElement('a', { href: 'shop', className: 'uppercase' }, 'View All Products')));
		}
	}, {
		key: 'sections',
		value: function sections() {
			return [{ title: 'Details', content: this.props.product.description }, { title: 'Features', content: this.props.product.features }, { title: 'Product Info', content: this.props.product.productInfo }, { title: 'How To Use', content: this.props.product.howToUse }].map(function (v) {
				return _react2.default.createElement(ProductSection, _extends({ key: v.title }, v));
			});
		}
	}, {
		key: 'canSubmitForm',
		get: function get() {
			return this.state.name && this.state.email && this.state.phone && this.state.location;
		}
	}]);

	return Product;
}(_react.Component);

exports.default = Product;